import World from './Experience/World'
import './style.css'

new World()